import Vuex from "vuex";
import Vue from "vue";

import user from "./modules/user";

import panelUser from "./modules/panelUser";

import readerAppUser from "./modules/readerAppUser";

import onBoardings from "./modules/onBoardings";

import companies from "./modules/companies";

import venues from "./modules/venues";

import productCategories from "./modules/productCategories";

import reports from "./modules/reports";

import campaigns from "./modules/campaigns";
import helpPage from "./modules/helpPage";
import subscriptionPlan from "@/store/modules/subscriptionPlan";
import applicationForm from "@/store/modules/applicationForm";
import applyMerchantForm from "@/store/modules/applyMerchantForm";
import banner from "@/store/modules/banner";
import contract from "./modules/contract";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    panelUser,
    readerAppUser,
    user,
    onBoardings,
    companies,
    venues,
    productCategories,
    reports,
    campaigns,
    helpPage,
    subscriptionPlan,
    applicationForm,
    applyMerchantForm,
    banner,
    contract
  },
});
